// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__14_TA","outer":"hero_outer__2I9np","inner":"hero_inner__1-irS","heading":"hero_heading__9ktwH"};